

<div #subDropdown (mouseenter)="openSubMenu()" (mouseleave)="closeSubMenu()" *ngIf="hasChild && hasParent && dataloaded" class="subdropdown">
  <a class="dropdown-item dropdown-toggle" id="subToggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="toggleSticky()">
    {{navElm.name}}
  </a>
  <div class="subdropdown-menu" aria-labelledby="navbarDropdown">
    <ul class="dropdown-menu">
        <li *ngFor="let elm of toArray(navElm.children)">
          <app-navigation-link *ngIf="hasChild" [navElm]="elm" [index]="index" (click)="closeSubMenuOnClick(elm)"></app-navigation-link>
        </li>
    </ul>
  </div>
</div>

<div #dropdown (mouseenter)="openMenu()" (mouseleave)="closeMenu()" *ngIf="hasChild && !hasParent && dataloaded && showDropdown" class="dropdown">
  <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="toggleSticky()">
    {{navElm.name}}
  </a>
  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
    <div *ngFor="let elm of toArray(navElm.children)">
      <app-navigation-link *ngIf="hasChild" [navElm]="elm" [index]="index" (click)="closeMenuOnClick(elm)" [parent]="this"></app-navigation-link>
    </div>
  </div>
</div>

<div *ngIf="!hasChild && hasParent && dataloaded">
  <div *ngIf="isURL(navElm.url)">
    <a *ngIf="!isDivider(navElm)" target="{{navElm.target}}" title="{{navElm.tooltip}}" (click)="navigate(navElm)" class="dropdown-item" [routerLink]="navElm.url" target="_blank">{{navElm.name}}</a>
    <div *ngIf="isDivider(navElm)" class="dropdown-divider"></div>
  </div>
  <div *ngIf="!isURL(navElm.url)">
    <a *ngIf="!isDivider(navElm)" target="{{navElm.target}}" title="{{navElm.tooltip}}" (click)="navigate(navElm)" class="dropdown-item" [routerLink]="navElm.url" target="_blank">{{navElm.name}}</a>
    <div *ngIf="isDivider(navElm)" class="dropdown-divider"></div>
  </div>
</div>

<div *ngIf="!hasChild && !hasParent && dataloaded">
  <div *ngIf="isURL(navElm.url)">
    <a *ngIf="index > 0; else first" class="nav-link" title="{{navElm.tooltip}}" (click)="navigate(navElm)" target="{{navElm.target}}" [routerLink]="navElm.url" target="_blank">{{navElm.name}}</a>
    <ng-template #first>
      <a class="nav-link pl-0" title="{{navElm.tooltip}}" (click)="navigate(navElm)" target="{{navElm.target}}" [routerLink]="navElm.url" target="_blank">{{navElm.name}}</a>
    </ng-template>
  </div>
  <div *ngIf="!isURL(navElm.url)">
    <a *ngIf="index > 0; else first" class="nav-link" title="{{navElm.tooltip}}" (click)="navigate(navElm)" target="{{navElm.target}}" [routerLink]="navElm.url" target="_blank">{{navElm.name}}</a>
    <ng-template #first>
      <a class="nav-link pl-0" title="{{navElm.tooltip}}" (click)="navigate(navElm)" target="{{navElm.target}}" [routerLink]="navElm.url" target="_blank">{{navElm.name}}</a>
    </ng-template>
  </div>
</div>

